import React, {useState} from 'react';
import {Button, Dialog, DialogBody, DialogFooter, DialogHeader, Typography} from "@material-tailwind/react";
import {LandingMenu} from "../components/common/LandingMenu";
import {PhoneIcon} from "@heroicons/react/16/solid";
import axios from "axios";
import {Link} from "react-router-dom";
import {Menu} from "../components/common/Menu";
import {EnvelopeIcon, GlobeAltIcon} from "@heroicons/react/24/outline";

import { motion } from 'framer-motion';

function KontaktPage() {

    const isAuthenticated = !!localStorage.getItem("token");

    const [poruka, setPoruka] = useState("");
    const [ime, setIme] = useState("");
    const [prezime, setPrezime] = useState("");
    const [nazivKompanije, setNazivKompanije] = useState("");
    const [naslov, setNaslov] = useState("");
    const [brojTelefona, setBrojTelefona] = useState("");
    const [email, setEmail] = useState("");
    const [openContactFormErrorDialog, setOpenContactFormErrorDialog] = useState(false);
    const [openErrorDialog, setOpenErrorDialog] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [openEmailConfirmationDialog, setOpenEmailConfirmationDialog] = useState(false);

    const currentYear = new Date().getFullYear();

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Provera svih obaveznih polja
        if (!poruka || !ime || !prezime || !email || !brojTelefona) {
            setOpenContactFormErrorDialog(true); // Otvori dijalog
            return;
        }

        try {
            // Priprema JSON podataka za slanje
            const kontaktHome = {
                poruka,
                datumSlanja: new Date().toLocaleString("sv-SE", { timeZone: "Europe/Belgrade" }).replace(" ", "T") + ".000Z",
                ime,
                prezime,
                nazivKompanije,
                naslov,
                brojTelefona,
                email
            };

            const API_URL = process.env.REACT_APP_API_URL;

            // Slanje običnog JSON objekta
            const response = await axios.post(`${API_URL}/contact/send`, kontaktHome);

            if (response.status === 200) {
                setOpenEmailConfirmationDialog(true); // Otvori dijalog
                setTimeout(() => {
                    setOpenEmailConfirmationDialog(false); // Automatski zatvori dijalog nakon 4 sekunde
                }, 5500);

                // Reset polja
                setIme("");
                setPrezime("");
                setNazivKompanije("");
                setNaslov("");
                setPoruka("");
                setEmail("");
                setBrojTelefona("");
            }
        } catch (error) {
            setErrorMessage("Došlo je do greške prilikom slanja poruke. Proverite vašu internet konekciju i pokušajte ponovo kasnije.");
            setOpenErrorDialog(true);
        }
    };

    const handleOpenContactFormErrorDialog = () => {
        setOpenContactFormErrorDialog(!openContactFormErrorDialog);
    };

    const handleOpenErrorDialog = () => {
        setOpenErrorDialog(!openErrorDialog);
    };

    const handleOpenEmailConfirmationDialog = () => {
        setOpenEmailConfirmationDialog(!openEmailConfirmationDialog);
    };


    return (
        <>
            <div className="overflow-hidden">
                <div className="justify-center w-[calc(100%)] min-h-screen bg-white">
                    <div className="h-5 bg-gray-50"></div>

                    <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                        {/* Levi krug */}
                        <div className="absolute w-[35vw] h-[35vw] bg-blue-100 rounded-full mix-blend-multiply filter blur-2xl opacity-50 animate-blob"
                             style={{ top: '90%', left: '30%', transform: 'translate(-80%, -50%)' }}></div>
                        {/* Desni krug */}
                        <div className="absolute w-[35vw] h-[35vw] bg-red-100 rounded-full mix-blend-multiply filter blur-2xl opacity-50 animate-blob animation-delay-2000"
                             style={{ top: '80%', left: '60%', transform: 'translate(-20%, -50%)' }}></div>
                        {/* Donji krug */}
                        {/*<div className="absolute w-[35vw] h-[35vw] bg-blue-100 rounded-full mix-blend-multiply filter blur-2xl opacity-50 animate-blob animation-delay-4000"*/}
                        {/*     style={{ top: '120%', left: '60%', transform: 'translate(-50%, 10%)' }}></div>*/}
                    </div>
                    <div className="mx-2">
                        {isAuthenticated ? <Menu /> : <LandingMenu />}

                        <motion.div
                            initial={{ opacity: 0, y: -100 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.75 }}
                        >

                        <div className="h-6 bg-grayblue-50"></div>
                        <div className="container mx-auto flex flex-col relative z-10">


                            <div
                                className="w-full h-[8rem] sm:h-[20rem] md:h-[20rem] rounded-lg bg-cover bg-center"
                                style={{ backgroundImage: "url('/images/kontakt-page/kontakt.jpg')" }}
                            ></div>

                            <div className="flex flex-col sm:flex-row gap-4 sm:gap-x-32 mt-8 ml-2 mr-2">
                                {/* Prvi div - O nama */}
                                <div className="w-full sm:w-1/2 flex flex-col gap-4">
                                    {/* Kontakt */}
                                    <div className="w-full">
                                        <span className="block text-blue-600 text-xl sm:text-2xl font-semibold mt-4 mb-6">Kontakt</span>
                                        <p className="mt-8 text-[17px] sm:text-xl font-light mb-8">
                                            Za sva Vaša pitanja ili nedoumice budite slobodni da nas <span className="font-semibold">kontaktirate</span> putem kontakt forme.
                                        </p>
                                        <p className="mt-8 text-[17px] sm:text-xl font-light mb-8">
                                            Jednostavno popunite kontakt formu i mi ćemo Vam odgovoriti u što kraćem vremenskom periodu.
                                        </p>
                                    </div>

                                    {/* Slika */}
                                    <div className="w-full">
                                        <div className="w-full flex items-center justify-start justify-center">
                                            <img
                                                src="/images/logo/transparent%20logo.png"
                                                alt="Smart Service System Logo"
                                                className="h-[6.75rem] w-auto"
                                            />
                                        </div>
                                        <div className="mt-4 text-center text-gray-700 text-sm sm:text-base font-light">
                                            <p className="font-semibold">SMART SERVICE SYSTEM</p>
                                            <p>BRAĆE MAŽAR 22</p>
                                            <p>21241 KAĆ, NOVI SAD</p>
                                            <p>REPUBLIKA SRBIJA</p>
                                            <p className="mt-2">MB: 65934353</p>
                                            <p>PIB: 112186523</p>
                                            <p className="mt-2">265-2050310001018-05 Raiffeisen Bank</p>
                                            <p className="mt-2 text-blue-600 font-medium">info@smartservicesystem.rs</p>
                                        </div>
                                    </div>
                                </div>


                                {/* Drugi div - Usmereni poslovi */}
                                <div className="w-full sm:w-1/2">
                                    <form className="space-y-6" onSubmit={handleSubmit}>
                                        {/* Select za izbor vrste prijave */}
                                        <div className="flex flex-col sm:flex-row gap-4 mb-4">
                                            {/* Deo za ime */}
                                            <div className="w-full sm:w-1/2">
                                                <label htmlFor="ime" className="text-gray-700 font-medium">Ime*</label>
                                                <input
                                                    id="ime"
                                                    name="ime"
                                                    type="text"
                                                    className="w-full px-4 py-3 mt-2 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                    value={ime}
                                                    onChange={(e) => setIme(e.target.value)}
                                                />
                                            </div>

                                            {/* Deo za prezime */}
                                            <div className="w-full sm:w-1/2">
                                                <label htmlFor="prezime" className="text-gray-700 font-medium">Prezime*</label>
                                                <input
                                                    id="prezime"
                                                    name="prezime"
                                                    type="text"
                                                    className="w-full px-4 py-3 mt-2 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                    value={prezime}
                                                    onChange={(e) => setPrezime(e.target.value)}
                                                />
                                            </div>
                                        </div>

                                        <div className="mb-4">
                                            {/* Deo za broj telefona */}
                                            <div className="w-full">
                                                <label htmlFor="nazivKompanije" className="text-gray-700 font-medium">Naziv Kompanije (opciono)</label>
                                                <input
                                                    id="nazivKompanije"
                                                    name="nazivKompanije"
                                                    type="text"
                                                    className="w-full px-4 py-3 mt-2 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                    value={nazivKompanije} // Ovaj input sada pokazuje samo broj telefona
                                                    onChange={(e) => setNazivKompanije(e.target.value)} // Samo unos broja telefona
                                                />
                                            </div>
                                        </div>

                                        <div className="flex flex-col sm:flex-row gap-4 mb-4">
                                            {/* Deo za email */}
                                            <div className="w-full sm:w-1/2">
                                                <label htmlFor="email" className="text-gray-700 font-medium">Email*</label>
                                                <input
                                                    id="email"
                                                    name="email"
                                                    type="text"
                                                    className="w-full px-4 py-3 mt-2 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                />
                                            </div>

                                            {/* Deo za broj telefona */}
                                            <div className="w-full sm:w-1/2">
                                                <label htmlFor="brojTelefona" className="text-gray-700 font-medium">Kontakt telefon*</label>
                                                <input
                                                    id="brojTelefona"
                                                    name="brojTelefona"
                                                    type="tel"
                                                    className="w-full px-4 py-3 mt-2 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                    value={brojTelefona}
                                                    onChange={(e) => setBrojTelefona(e.target.value)}
                                                />
                                            </div>
                                        </div>

                                        <div className="mb-4">
                                            {/* Deo za broj telefona */}
                                            <div className="w-full">
                                                <label htmlFor="naslov" className="text-gray-700 font-medium">Naslov</label>
                                                <input
                                                    id="naslov"
                                                    name="naslov"
                                                    type="text"
                                                    className="w-full px-4 py-3 mt-2 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                    value={naslov} // Ovaj input sada pokazuje samo broj telefona
                                                    onChange={(e) => setNaslov(e.target.value)} // Samo unos broja telefona
                                                />
                                            </div>
                                        </div>

                                        {/* Textarea za unos poruke */}
                                        <div className="mb-2">
                                            <label htmlFor="poruka" className="text-gray-700 font-medium">Vaša poruka*</label>
                                            <textarea
                                                id="poruka"
                                                name="poruka"
                                                rows="5"
                                                className="w-full px-4 py-3 mt-2 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                value={poruka}
                                                onChange={(e) => setPoruka(e.target.value)}
                                                maxLength={4000}
                                            ></textarea>
                                            {/* Flex container za attachment i brojač karaktera */}
                                            <div className="flex items-center justify-between mt-1">
                                                {/* Brojač karaktera */}
                                                <div className={`text-sm ${poruka.length === 4000 ? "text-red-500" : "text-gray-500"}`}>
                                                    {poruka.length}/4000
                                                </div>
                                            </div>
                                        </div>

                                        {/* Dugme za slanje */}
                                        <div className="mb-4">
                                            <button
                                                type="submit"
                                                className="text-white font-semibold py-3 px-6 sm:py-4 sm:px-8 rounded-full shadow-lg bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-r hover:from-blue-600 hover:via-blue-700 hover:to-blue-800 transition-all duration-300 mt-4"
                                            >
                                                Pošaljite
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>

                            <Dialog open={openErrorDialog} handler={handleOpenErrorDialog}>
                                <DialogHeader>Greška</DialogHeader>
                                <DialogBody>
                                    <p>{errorMessage}</p>
                                </DialogBody>
                                <DialogFooter>
                                    <Button
                                        variant="gradient"
                                        color="red"
                                        onClick={handleOpenErrorDialog}
                                    >
                                        U redu
                                    </Button>
                                </DialogFooter>
                            </Dialog>

                            <Dialog open={openContactFormErrorDialog} handler={handleOpenContactFormErrorDialog}>
                                <DialogHeader>Greška prilikom slanja poruke</DialogHeader>
                                <DialogBody>
                                    <p>Molimo vas popunite sva obavezna polja i pokusajte opet.</p>
                                </DialogBody>
                                <DialogFooter>
                                    <Button
                                        variant="gradient"
                                        color="blue"
                                        onClick={handleOpenContactFormErrorDialog}
                                    >
                                        U redu
                                    </Button>
                                </DialogFooter>
                            </Dialog>

                            <Dialog open={openEmailConfirmationDialog} handler={handleOpenEmailConfirmationDialog}>
                                <DialogHeader>Poruka poslata</DialogHeader>
                                <DialogBody>
                                    <p>Vaša poruka je poslata. Odgovorićemo vam u najkraćem mogućem roku.</p>
                                    <p className="mt-2">Hvala što ste nas kontaktirali.</p>
                                </DialogBody>
                                <DialogFooter>
                                    <Button
                                        variant="gradient"
                                        color="blue"
                                        onClick={handleOpenEmailConfirmationDialog}
                                    >
                                        U redu
                                    </Button>
                                </DialogFooter>
                            </Dialog>

                            <div className="flex gap-4 mt-24 mb-4">
                                <footer className="relative w-full">
                                    <div className="mx-auto w-full max-w-7xl px-8">
                                        <div className="mx-auto grid w-full grid-cols-1 gap-8 py-12 md:grid-cols-2 lg:grid-cols-4">

                                            <div className="w-full flex items-center justify-start lg:justify-center">
                                                <img
                                                    src="/transparent logo.png"
                                                    alt="Smart Service System Logo"
                                                    className="h-24 w-auto"
                                                />
                                            </div>

                                            <div className="w-full">
                                                <Typography variant="small" className="mb-4 font-bold uppercase text-gray-900">
                                                    Navigacija
                                                </Typography>
                                                <ul className="space-y-1">
                                                    <Link to="/">
                                                        <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                            <span className="inline-block py-1 pr-2">Početna strana</span>
                                                        </Typography>
                                                    </Link>
                                                    <Link to="/o_nama">
                                                        <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                            <span className="inline-block py-1 pr-2">O nama</span>
                                                        </Typography>
                                                    </Link>
                                                    <Link to="/saveti">
                                                        <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                            <span className="inline-block py-1 pr-2">Saveti</span>
                                                        </Typography>
                                                    </Link>
                                                    <Link to="/kontakt">
                                                        <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                            <span className="inline-block py-1 pr-2">Kontakt</span>
                                                        </Typography>
                                                    </Link>
                                                </ul>
                                            </div>

                                            <div className="w-full">
                                                <Typography variant="small" className="mb-4 font-bold uppercase text-gray-900">
                                                    Kontakt
                                                </Typography>
                                                <ul className="space-y-1">
                                                    <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                        <span className="inline-block py-1 pr-2">Za sva Vaša pitanja</span>
                                                    </Typography>
                                                    <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                        <span className="inline-block py-1 pr-2">stojimo na raspolaganju</span>
                                                    </Typography>
                                                    <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                        <span className="inline-block py-1 pr-2">svakog radnog dana</span>
                                                    </Typography>
                                                    <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                        <span className="inline-block py-1 pr-2">od 12-14h</span>
                                                    </Typography>
                                                </ul>
                                            </div>

                                            <div className="w-full">
                                                <div className="flex items-center space-x-4 mb-4">
                                                    <GlobeAltIcon className="h-5 w-5 text-gray-900" />
                                                    <EnvelopeIcon className="h-5 w-5 text-gray-900" />
                                                    <PhoneIcon className="h-5 w-5 text-gray-900" />
                                                </div>
                                                <ul className="space-y-1">
                                                    <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                        <span className="inline-block py-1 pr-2">www.smartservicesystem.rs</span>
                                                    </Typography>
                                                    <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                        <span className="inline-block py-1 pr-2">info@smartservicesystem.rs</span>
                                                    </Typography>
                                                    <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                        <span className="inline-block py-1 pr-2">+381 61 528 00 18</span>
                                                    </Typography>
                                                    <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                        <a  href="/Politika%20privatnosti.pdf" target="_blank" rel="noopener noreferrer" className="inline-block py-1 pr-2">Politika privatnosti</a>
                                                    </Typography>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="flex w-full flex-col items-center justify-center border-t border-blue-gray-50 py-4 md:flex-row md:justify-between">
                                            <Typography
                                                variant="small"
                                                className="mb-4 text-center font-normal text-blue-gray-900 md:mb-0"
                                            >
                                                &copy; {currentYear} <a href="https://smartservicesystem.rs/">Smart Service System</a>. Sva
                                                prava zadržana.
                                            </Typography>
                                        </div>
                                    </div>
                                </footer>
                            </div>

                        </div>
                        </motion.div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default KontaktPage;